import type { CertificationModuleShallow } from "@brookbush/types";

import clsx from "clsx";
import { useRouter } from "next/compat/router";
import Link from "next/link";

import { useCertification } from "~/hooks";

interface CertificationCatalogueItemProps {
	module: CertificationModuleShallow;
}

const CertificationCatalogueItem = ({
	module,
}: CertificationCatalogueItemProps) => {
	const { moduleSlug, certificationSlug } = (useRouter()?.query ?? {}) as {
		moduleSlug: string;
		certificationSlug: string;
	};

	const { isLoading } = useCertification();

	const isCurrentModule = moduleSlug === module.slug;

	const isPassed =
		module.earnedCoreCredits && module.earnedCoreCredits >= module.credits;

	return (
		<Link
			className={clsx(
				"certification-catalogue-item -mx-1 flex items-center gap-3 rounded-xl px-3 py-2.5 hover:bg-slate-50 dark:hover:bg-slate-700/50",
				{
					"bg-slate-100/80 dark:bg-slate-700": isCurrentModule,
				},
				{
					"certification-catalogue-electives": module.slug === "electives",
				},

				{
					"animate-pulse": isLoading,
				},
			)}
			href={`/certifications/${certificationSlug}/modules/${module.slug}`}
		>
			<span
				className={clsx(
					"certification-catalogue-item-credits box-content flex h-6 w-12 shrink-0 items-center justify-center rounded-full p-0 font-medium text-[0.8rem]",
					isPassed
						? "bg-emerald-100 dark:bg-emerald-300/30 dark:text-slate-50"
						: module.slug === "electives"
							? "bg-purple-100 dark:bg-purple-300/30 dark:text-slate-50"
							: "bg-sky-100 dark:bg-sky-300/30 dark:text-slate-50",
				)}
			>
				{module.earnedCoreCredits}{" "}
				{module.earnedCoreCredits !== undefined && "/"} {module.credits}
			</span>

			<span>{module.title}</span>
		</Link>
	);
};

export default CertificationCatalogueItem;
